export default "__VITE_ASSET__BMFDJRCN__"